import React, { useState } from 'react';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Typography from '@material-ui/core/Typography';
import TextField from '../common/Input';
import Button from '../common/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import InputLabel from '@material-ui/core/InputLabel';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';

const AddTag = (props) => {
  const { classes } = props;
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (<div>
    <Button size="small" label="Add New FAQ" onClick={()=> handleClickOpen()}></Button>      
    <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" fullWidth={true}>
        <DialogTitle id="form-dialog-title">Add New FAQ</DialogTitle>
        <DialogContent>
          <TextField
            id="standard-full-width"
            label="Question"
            placeholder="Add Question"
            inputProps={{
                style: {
                    border: '1px solid grey',
                    borderRadius: '4px',
                    padding: '10px 20px',
                    margin: '10px 0',
                    background: 'none'
                }
            }}
          />
          <div className={classes.discount}>
          <InputLabel shrink={true} classes={{ root: classes.discountlabel }}>Answer</InputLabel>
          <div className={classes.textField}>
            <TextareaAutosize
              className={classes.answer}
              rowsMin={5}
              aria-label="maximum height"
              placeholder="Add your answer"
            />
          </div>
         </div>
         
         <Button onClick={handleClose} color="primary" label="Add"/>
        </DialogContent>
    </Dialog>
    { false && <Card className={classes.root}>
      <CardHeader subheader="Add Tag" classes={ { subheader: classes.header }}/>
      <CardContent>
        <TextField
          label="Tag Name"
          placeholder="Add Tag name"          
        />
        <Button size="small" label="Add" onClick={()=> console.log("CLicked")}></Button>      
      </CardContent>
    </Card> }
  </div>)
}


export default AddTag;
